
import { AnyAction } from 'redux';
import { IGeoPosState, GEOPOS_STATE } from './geographicalpos.model';
import { GeoPosActionService } from './geographicalpos.action';

export function geoposReducer(state: IGeoPosState =  GEOPOS_STATE, action: AnyAction): IGeoPosState {

    switch (action.type) {

        case GeoPosActionService.GEOPOS_LIST:
            return {
              ...state,
                list: action.payload
            };

        case GeoPosActionService.SET_GEOPOS_CURRENT:
            return {
              ...state,
                current: action.payload
            };

        case GeoPosActionService.ADD_GEOPOS:
          return {
            ...state,
            list: [...state.list, action.payload]
          };

        case GeoPosActionService.DELETE_GEOPOS:
          const list = state.list.filter(geopos => geopos.id != action.payload);
          return {
            ...state,
            list
          };

    }

    return state;
}
